<script>
    import Clipboard from '@/common/clipboard';
    import TimelineMessageModel from '@/common/models/timeline-message-model';
    import TimelineMessageDataModel from '@/common/models/timeline-message-data-model';
    import {vIcon} from '@/components/form/index';
    import MessagesMixins from '../messages/messages-mixins';
    import injectMessageLinks from '@/components/timeline/components/message-summary/inject-message-links';
    import highlightStates from '@/components/timeline/components/message-summary/highlight-states';

    export default {
        name: 'message-summary',
        components: {},
        mixins: [MessagesMixins],
        props: {
            type: {
                type: String,
                required: true,
            },
            entityId: {
                type: String,
                required: true,
            },
            isOpen: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            renderActions(h) {
                const actions = [];
                // is it necessary to render the Copy Gateway Response button
                if (this.message.type === TimelineMessageModel.Types.gatewayResponseReceived && Clipboard.isSupported) {
                    actions.push(h('span', {
                        props: {
                            size: 'small',
                        },
                        class: 'inline-s has-tooltip',
                        attrs: {
                            'data-tooltip': 'Copy',
                        },
                        on: {
                            click: async (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                try {
                                    await Clipboard.copy(this.message.getUserFriendlyPayload());
                                    this.$toast.positive(`Event data was copied to the clipboard`);
                                } catch (err) {
                                    this.$toast.negative(`Something went wrong. Please copy manually`);
                                }
                            },
                        },
                    }, [
                        h(vIcon, {props: {icon: 'clone'}}),
                    ]));
                }
                return actions;
            },
            renderSummaryActions(h) {
                const actions = [];

                // {Object|undefined} - edit action object or undefined
                const editDisputeAction = this.message.extraData.getAction(TimelineMessageDataModel.ExtraDataActions.editDispute);

                if (editDisputeAction) {
                    actions.push(h('span', {
                        class: 'inline-s',
                        on: {
                            click: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            },
                        },
                    }, [
                        h('router-link', {
                            props: {
                                to: {name: 'update-dispute', params: {id: editDisputeAction.disputeId}},
                            },
                        }, 'Edit dispute'),
                    ]));
                }
                return actions;
            },
            renderActionsColumn(h) {
                return h('div', {class: 'grid-item no-flex'}, [
                    ...this.renderActions(h),
                    h('a', {
                        class: 'text-muted timeline-message-time',
                        title: this.message.dateTime,
                        attrs: {
                            href: this.message.anchorId,
                        },
                        on: {
                            click: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                document.location.hash = e.target.getAttribute('href');
                            },
                        },
                    }, [this.message.time]),
                ]);
            },
            renderCaretIcon(h) {
                return this.message.hasDetails ? h(vIcon, {
                    props: {
                        icon: 'caret-right',
                    },
                    class: this.isOpen ? 'is-rotating-right' : '',
                }) : undefined;
            },
            renderSummaryText(createElement) {
                const message = [this.message.message];
                const {links} = this.message.extraData;
                const linksProcessed = injectMessageLinks({
                    message,
                    createElement,
                    links,
                    component: this,
                    // disable itself link
                    isDisabledLink: ({resourceType, resourceId}) => resourceType === this.type && resourceId === this.entityId,
                });
                return createElement(
                    'div',
                    {
                        class: 'display-inline-block fs-block inline-s',
                        style: {
                            maxWidth: '95%',
                        },
                    },
                    highlightStates({linksProcessed, createElement}),
                );
            },
        },
        render(h) {
            return h('div', {
                class: 'grid-fitted grid-unstackable timeline-message-summary',
                on: {
                    click: e => this.$emit('click', e),
                },
            }, [
                h('div', {class: 'grid-item'}, [
                    this.renderSummaryText(h),
                    this.renderSummaryActions(h),
                    this.renderCaretIcon(h),
                ]),
                this.renderActionsColumn(h),
            ]);
        },
    };
</script>

<style>
    .timeline-message-time,
    .timeline-message-time:focus {
        outline: none;
        box-shadow: none;
    }

    .timeline-message-time:hover {
        cursor: pointer;
    }
</style>
